exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__NSroot___1Jklt{display:flex;justify-content:center;align-items:center;height:3rem;border-radius:30px 5px 0 0}.styles__NSroot___1Jklt .styles__name___knPjv{padding-right:.5rem}", ""]);

// exports
exports.locals = {
	"NSroot": "styles__NSroot___1Jklt",
	"name": "styles__name___knPjv"
};